import { IconPen } from '../Icons/IconPen';

export const ButtonEdit = ({ data }) => (
	<button type="button" { ...data }>
		<IconPen fill="currentColor" />
	</button>
)

ButtonEdit.name = 'ButtonEdit';
